export default __webpack_public_path__ + "static/media/cause.bfcc3d99.svg";